module.exports = __webpack_public_path__ + "img/scirpophaga-incertulas.43568f68.jpg";